import { MoneyBox } from '@apply/components';
import { useExperienceSalesPrice } from '../../../../fields/ExperienceFields';

interface SalesPriceProps {
    experienceId: string | undefined;
    required?: boolean;
    readOnly?: boolean;
}

export const SalesPrice: React.FC<SalesPriceProps> = ({ experienceId, required = false, readOnly }) => {
    const label = 'Sales Price ';
    const [salesPrice, set_salesPrice] = useExperienceSalesPrice(experienceId);

    return (
        <>
            <MoneyBox
                id='experienceSalesPrice'
                allowNegative={false}
                value={salesPrice}
                onChange={(value) => {
                    set_salesPrice(value);
                }}
                required={required}
                label={label}
                displayChange={false}
                max={100000000}
                min={0}
                readOnly={readOnly}
            />
        </>
    );
};
